import { doRequest } from '@r1-frontend/do-request';
import getBodyForRequestEquipment from '@r1-frontend/api-domru/api-tariffs/v1/tariffs/[salePackageId]/equipment';
import { ResponseDto, ResponseEquipmentDto } from '@r1-frontend/api-domru/api-tariffs/v1/tariffs/[salePackageId]/equipment/dto/ResponseDto';

import isOnlyPurchaseEquipment from '~/src/features/full-buy/helpers/ab/isOnlyPurchaseEquipment';
import { setProducts, toggleBackgroundLoading } from '~/src/features/full-buy/store/actions';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { TDispatch, TGetState } from '~/src/store';

const processEquipment = (equipment: ResponseEquipmentDto): TProduct => ({
    id: equipment.globalId || equipment.contentId,
    category: equipment.category.name,
    categoryTitle: equipment.category.title,
    title: equipment.title,
    description: equipment.fullBody,
    body: equipment.body,
    props: equipment.characteristics || [],
    // it is only for type assertion
    labels: equipment.labels.map(l => ({
        id: l.id,
        name: l.name,
        title: l.title,
        color: l.color || '',
        color_text: l.color_text || '',
    })) || [],

    image: equipment.images.shift() || '',
    images: equipment.images,

    prices: equipment.prices.map(p => ({ duration: p.duration === 1 ? 0 : p.duration, cost: p.value })),
    selectedPrice: { duration: equipment.prices[0].duration === 1 ? 0 : equipment.prices[0].duration, cost: equipment.prices[0].value },

    quantity: 0,
});

/**
 * Getting only purchasing routers for the WEB-50023 issue
 * @link https://ticket.ertelecom.ru/browse/WEB-50023
 */
const getOnlyPurchasePrices = (router: ResponseEquipmentDto) => {
    return {
        ...router,
        prices: router.prices.filter(price => price.duration === 1 && price.type === 1),
    };
};

const getEquipment = () => async(dispatch: TDispatch, getState: TGetState) => {
    const tariff = selectCurrentTariff(getState());

    if (!tariff) {
        return;
    }

    dispatch(toggleBackgroundLoading(true));

    const response = await doRequest.apiTariffs<ResponseDto>(getBodyForRequestEquipment(tariff.sale_package_id));

    if (response.isSuccess) {
        if (isOnlyPurchaseEquipment()) {
            dispatch(setProducts([
                ...response.payload.routers.map(getOnlyPurchasePrices).map(processEquipment),
                ...response.payload.decoders.map(getOnlyPurchasePrices).map(processEquipment),
                ...response.payload.privateSectorEquipment.map(getOnlyPurchasePrices).map(processEquipment),
                ...response.payload.yandex.map(getOnlyPurchasePrices).map(processEquipment),
            ]));
        } else {
            dispatch(setProducts([
                ...response.payload.routers.map(processEquipment),
                ...response.payload.decoders.map(processEquipment),
                ...response.payload.privateSectorEquipment.map(processEquipment),
                ...response.payload.yandex.map(processEquipment),
            ]));
        }
    }

    dispatch(toggleBackgroundLoading());
};

export default getEquipment;
